import { createContext, useContext, PropsWithChildren } from 'react';
import type { HeadCollector } from '../utils/createHeadCollector';

const HeadCollectorContext = createContext<HeadCollector | null>(null);

export const HeadCollectorProvider = ({
  children,
  collector,
}: PropsWithChildren<{ collector: HeadCollector }>) => {
  return (
    <HeadCollectorContext.Provider value={collector}>{children}</HeadCollectorContext.Provider>
  );
};

export const useHeadCollector = () => useContext(HeadCollectorContext);
